import { GET, PATCH, POST, DELETE } from '../common/common.service'
import endpointsAccountingEntry from './endpoints'

const AccountingEntryService = {
  getAccountingEntry: async ({ companyCode, filter, sort, limit, skip }) =>
    companyCode
      ? GET(
          endpointsAccountingEntry.ACCOUNTING_ENTRY(
            companyCode,
            filter,
            sort,
            limit,
            skip,
          ),
        )
      : {},
  getAccountingEntryLast: async ({
    companyCode,
    year,
    month,
    filter,
    sort,
    limit,
    skip,
  }) =>
    companyCode
      ? GET(
          endpointsAccountingEntry.ACCOUNTING_ENTRY_LAST(
            companyCode,
            year,
            month,
            filter,
            sort,
            limit,
            skip,
          ),
        )
      : {},
  getCompanies: async ({ filter, sort, limit, skip }) =>
    GET(endpointsAccountingEntry.COMPANIES(filter, sort, limit, skip)),
  generate: async (body) => POST(endpointsAccountingEntry.GENERATE, body),
  send: async (id) => POST(endpointsAccountingEntry.SEND(id)),
  download: async (id) => GET(endpointsAccountingEntry.DOWNLOAD(id)),

  accounts: {
    getAccounts: async ({ companyCode, filter, sort, limit, skip }) =>
      companyCode
        ? GET(
            endpointsAccountingEntry.ACCOUNTS.LOAD(
              companyCode,
              filter,
              sort,
              limit,
              skip,
            ),
          )
        : {},
  },

  agreements: {
    getAgreements: async ({ companyCode, filter, sort, limit, skip }) =>
      companyCode
        ? GET(
            endpointsAccountingEntry.AGREEMENTS.LOAD(
              companyCode,
              filter,
              sort,
              limit,
              skip,
            ),
          )
        : {},
  },

  analitics: {
    getAnalitics: async ({ id, filter, sort, limit, skip }) =>
      id
        ? GET(
            endpointsAccountingEntry.ANALITICS.LOAD(
              id,
              filter,
              sort,
              limit,
              skip,
            ),
          )
        : {},
    getAccountingEntryAnalitics: async ({ id, filter, sort, limit, skip }) =>
      id
        ? GET(
            endpointsAccountingEntry.ANALITICS.ACCOUNTING_ENTRY_LOAD(
              id,
              filter,
              sort,
              limit,
              skip,
            ),
          )
        : {},
  },

  concepts: {
    getConcepts: async ({
      companyCode,
      agreementCode,
      filter,
      sort,
      limit,
      skip,
    }) =>
      companyCode
        ? GET(
            endpointsAccountingEntry.CONCEPTS.LOAD(
              companyCode,
              agreementCode,
              filter,
              sort,
              limit,
              skip,
            ),
          )
        : {},
  },

  projects: {
    getProjects: async ({ companyCode, filter, sort, limit, skip }) =>
      companyCode
        ? GET(
            endpointsAccountingEntry.PROJECTS.LOAD(
              companyCode,
              filter,
              sort,
              limit,
              skip,
            ),
          )
        : {},
  },

  templates: {
    getTemplates: async ({ companyCode, filter, sort, limit, skip }) =>
      companyCode
        ? GET(
            endpointsAccountingEntry.TEMPLATES.LOAD(
              companyCode,
              filter,
              sort,
              limit,
              skip,
            ),
          )
        : {},
    addTemplate: async (body) =>
      POST(endpointsAccountingEntry.TEMPLATES.ADD_TEMPLATE, body),
    updateTemplate: async (id, body) =>
      id
        ? PATCH(endpointsAccountingEntry.TEMPLATES.UPDATE_TEMPLATE(id), body)
        : null,
    deleteTemplate: async (id) =>
      id
        ? DELETE(endpointsAccountingEntry.TEMPLATES.DELETE_TEMPLATE(id))
        : null,
  },

  workers: {
    getWorkers: async ({
      companyCode,
      year,
      month,
      filter,
      sort,
      limit,
      skip,
    }) =>
      companyCode
        ? GET(
            endpointsAccountingEntry.WORKERS.LOAD(
              companyCode,
              year,
              month,
              filter,
              sort,
              limit,
              skip,
            ),
          )
        : {},
    getWorkersWithoutProject: async ({
      companyCode,
      year,
      month,
      filter,
      sort,
      limit,
      skip,
    }) =>
      companyCode
        ? GET(
            endpointsAccountingEntry.WORKERS.LOAD_WITHOUT_PROJECT(
              companyCode,
              year,
              month,
              filter,
              sort,
              limit,
              skip,
            ),
          )
        : {},
    setProjects: async (body) =>
      body ? PATCH(endpointsAccountingEntry.WORKERS.SET_PROJECTS, body) : null,
    removeWorker: async (id) =>
      id ? DELETE(endpointsAccountingEntry.WORKERS.REMOVE(id)) : null,
  },
}

export default AccountingEntryService
